export default __webpack_public_path__ + "static/media/tete63.49328338.png";